"use client";
import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <button onClick={scrollToTop} className={`${isVisible ? "opacity-100" : "opacity-0 pointer-events-none"} fixed right-4 bottom-18.75 w-11.5 h-11.5 sm:w-12 sm:h-12 rounded-full transition-opacity duration-300 z-150`} aria-label="Scroll to top">
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-11.5 h-11.5 sm:w-12 sm:h-12 shadow-[0_4px_4px_0_#1A51AA20] text-(--text) rounded-full">
          <g data-figma-bg-blur-radius="24.09">
            <rect width="44" height="44" rx="22" fill="white" />
            <rect x="0.55" y="0.55" width="42.9" height="42.9" rx="21.45" stroke="currentColor" strokeOpacity="0.5" strokeWidth="1.1" />
            <path d="M14.9961 25L21.9961 18L28.9961 25" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="bgblur_0_9396_70757_clip_path" transform="translate(0 0)">
              <rect width="44" height="44" rx="22" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </>
  );
}
